var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppBar-MenuWithActivator',{attrs:{"transparent":_vm.transparent,"button-props":{
		text: _vm.data.text,
		icon: _vm.data.icon,
		iconHtml: _vm.data.iconHtml,
		iconImage: _vm.data.iconImage,
		iconType: _vm.data.iconType,
	}}},[_c('div',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticClass:"w100",staticStyle:{"max-width":"1440px"}},[_c('AppBar-ImagesCarousel',{attrs:{"slides-per-page":_vm.cSlidesPerPage,"slides":_vm.data.imagesCarousel}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }